import { RichText } from '@graphcms/rich-text-react-renderer';
import { CorpCustomRenderers } from '../../LongText';
import { ContainerBodyText, ImageWrapper } from './styles';

const BodyText = ({ pressRelease }: any) => {
  return (
    <ContainerBodyText>
      <RichText
        content={pressRelease?.content?.json}
        renderers={{
          ...CorpCustomRenderers,
          Asset: {
            image: (props) => (
              <ImageWrapper>
                <img alt="" src={props.url} className="lazy" />
              </ImageWrapper>
            ),
          },
        }}
        references={pressRelease?.content?.references}
      />
    </ContainerBodyText>
  );
};

export default BodyText;
